/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import $ from 'jquery';
import * as filterMetadata from '@bingads-webui/filter-commons';
export default {
  refresh: function (grid, cb) {
    if (grid.gridView) {
      grid.gridView.refresh(true);
      if (_.isFunction(cb)) {
        grid.gridView.once('didReload', cb);
      }
    } else {
      _.isFunction(cb) ? grid.go().then(cb, cb) : grid.go();
    }
  },
  onBulkEditViewHide: function (view, grid) {
    if (grid.gridView) {
      view.trigger('hide');
    } else {
      grid.gridDom.trigger('showToolbar');
    }
  },
  unbindRowSelection: function (grid) {
    if (!grid.gridView) {
      grid.gridDom.unbind(grid.rowSelectionChanged + '.ruleAuthoringEvents');
    }
  },
  getSelectedRowIds: function (grid) {
    if (grid) {
      return grid.gridView ? grid.gridView.selectedKeys() : grid.getSelectedRowIds();
    }
    return null;
  },
  isCrossPageAllSelected: function (grid) {
    if (grid.gridView) {
      return grid.pgridPlugins.crossPageSelectAll.isAllSelected;
    } else {
      return grid.getSelectionScope() === 'AllPages';
    }
  },
  getTotalRowsCount: function (grid) {
    if (grid.gridView) {
      return grid.gridView.totalCountRows;
    } else {
      return grid.getTotalRecordCount();
    }
  },
  getSelectedRows: function (grid) {
    if (grid) {
      return grid.gridView ? grid.gridView.selectedItems() : grid.getSelectedRowItems();
    }
    return [];
  },
  getSelectedRowsCount: function (grid) {
    if (grid) {
      var isCrossPageAllSelected = this.isCrossPageAllSelected(grid);
      return isCrossPageAllSelected ? this.getTotalRowsCount(grid) : this.getSelectedRowIds(grid).length;
    }
    return 0;
  },
  deselectAll: function (grid) {
    if (grid.gridView) {
      return grid.gridView.deselectAll();
    } else {
      return grid.toggleAllRows(false, true);
    }
  },
  getSelectedEntityIds: function (grid) {
    if (grid) {
      var ids = grid.gridView ? grid.gridView.selectedKeys() : grid.getSelectedRowIds();
      ids = _.map(ids, function (value) {
        var indexOf_ = value.indexOf('_');
        if (indexOf_ < 0) return parseInt(value);
        return parseInt(value.substring(0, value.indexOf('_')));
      });
      return ids;
    }
    return null;
  },
  allPageSelected: function (grid) {
    if (grid.crossPageSelectAll) {
      return grid.crossPageSelectAll.isAllSelected;
    } else if (grid.pgridPlugins) {
      return grid.pgridPlugins.crossPageSelectAll && grid.pgridPlugins.crossPageSelectAll.isAllSelected;
    } else {
      return grid.getSelectionScope() === 'AllPages';
    }
  },
  getPageSize: function (grid) {
    return grid.pgridPlugins && grid.pgridPlugins.pagination ? grid.pgridPlugins.pagination.pageSize : grid.getPageSize();
  },
  getCurrentPage: function (grid) {
    return grid.pgridPlugins && grid.pgridPlugins.pagination ? grid.pgridPlugins.pagination.pageNumber : grid.getCurrentPage();
  },
  getColumnValue: function (grid, rowId, columnName) {
    if (grid.gridView) {
      return _.result(grid.gridView.itemWithKey(rowId), columnName);
    }
    return grid.getColumnValue(rowId, columnName);
  },
  getSortInfo: function (entity, grid) {
    var sortParams = {};
    var sortInfo = '';
    if (grid.gridView) {
      var sort = grid.gridView.get('sortableHeader');
      sortParams.ColumnId = sort.name;
      sortParams.Direction = sort.direction <= 0 ? 'd' : 'a';
    } else {
      sortParams = grid.sortInfo;
    }
    if (sortParams && sortParams.ColumnId) {
      if (grid.gridView) {
        var orderby = grid.gridView.get('query').orderby;
        if (orderby && orderby.length > 0) {
          sortInfo = orderby[0].key;
        }
      } else {
        sortInfo = filterMetadata.columnNameMapper(sortParams.ColumnId, entity);
      }
      if (sortParams.Direction === 'd') {
        sortInfo += ' desc';
      }
    }
    return sortInfo;
  },
  hideToolbar: function (grid) {
    if (grid.gridView) {
      grid.toolbar.gridToolbarGroup.hideAllToolbars();
    } else {
      grid.gridDom.trigger('hideToolbar');
    }
  },
  showToolbar: function (grid) {
    if (grid.gridView) {
      grid.toolbar.gridToolbarGroup.showAllToolbars();
    } else {
      grid.gridDom.trigger('showToolbar');
    }
  },
  hideGroupMenu: function (grid) {
    if (!grid.gridView) {
      grid.hideGroupMenu();
    }
  },
  loadPage: function (grid, data) {
    if (grid.gridView) {
      grid.gridView.refresh(true);
    } else {
      grid.loadPage(data);
    }
  }
};

